import { listTileReducerFactory } from '../../../pillar/dashboard/store/reducers/list-tile.reducerFactory';
import { TileState } from '../../../pillar/dashboard/store/state/TileState';
import * as actions from '../actions/';
import { ModuleConfiguration } from '../../messages.module.config';
import { MessagesListModel } from '../../models/MessagesListModel';
import { MessagesModel } from '../../models/MessagesModel';
import { IMessagesState } from '../state/IMessagesState';
import { DateFramedMessageModel } from '../../models/DateFramedMessageModel';
import { SignalRClientAction, SIGNALR_CLIENT_ACTION } from '../../../core/store/action/SignalRClientAction';

export const initialState: IMessagesState = {
  messages: undefined
}

export function messagesReducer(state = initialState, action: actions.Actions | SignalRClientAction) {
  switch (action.type) {
    case SIGNALR_CLIENT_ACTION:
      var signalRAction = (action as SignalRClientAction);
      if (signalRAction.payload.actionName === 'MessagesUpdated')
      return {
        ...state,
        messages: signalRAction.payload.model
        };

    case actions.GET_MESSAGES_SUCCESS_ACTION:
      var model = (action as actions.GetMessagesSuccessAction).payload.messages;
      return {
        ...state,
        messages: model
      };

    case actions.ACTIVATE_DRAFT_DISCLAIMER_DESCRIPTION_SUCCESS_ACTION:
      var newActiveDisclaimer = (action as actions.ActivateDraftDisclaimerDescriptionSuccessAction).payload.activatedDisclaimer;
      return {
        ...state,
        messages: {
          ...state.messages,
          draftDisclaimerDescription: "",
          activeDisclaimerDescription: newActiveDisclaimer
        }
      };

    case actions.EXPIRE_NOTIFICATION_SUCCESS_ACTION:
      var expireAction = action as actions.ExpireNotificationSuccessAction;
      var expiredNotification = expireAction.payload.expiredNotification;
      var index = state.messages.activeNotifications.findIndex(n => n.key === expiredNotification.key);
      var activeNotification = state.messages.activeNotifications;
      if (index > -1) {
        activeNotification.splice(index, 1);
      }
      var historyNotifications = state.messages.historyNotifications;
      historyNotifications.push(expiredNotification);
      return {
        ...state,
        messages: {
          ...state.messages,
          activeNotifications: activeNotification.sort((n1, n2) => {
            if (n1.expirationTimestamp > n2.expirationTimestamp) {
              return 1;
            }
            if (n1.expirationTimestamp < n2.expirationTimestamp) {
              return -1;
            }
            return 0;
          }),
          historyNotifications: historyNotifications.sort((n1, n2) => {
            if (n1.expirationTimestamp < n2.expirationTimestamp) {
              return 1;
            }
            if (n1.expirationTimestamp > n2.expirationTimestamp) {
              return -1;
            }
            return 0;
          }).slice(0, 5)
      }
      };
    case actions.ACTIVATE_DRAFT_BROADCAST_MESSAGE_SUCCESS_ACTION:
      var activeBroadcast = (action as actions.ActivateDraftBroadcastMessageSuccessAction).payload.activatedBroadcast;
      return {
        ...state,
        messages: {
          ...state.messages,
          draftBroadcastMessage: undefined,
          activeBroadcastMessage: activeBroadcast,
        }
      };
    case actions.EXPIRE_BROADCAST_SUCCESS_ACTION:
      var expiredBroadcast = (action as actions.ExpireBroadcastSuccessAction).payload.expiredBroadcast;
      return {
        ...state,
        messages: {
          ...state.messages,
          $type: "expiredBroadcast",
          activeBroadcastMessage: expiredBroadcast
        }
      };
  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/messages/store/reducers/Messages.reducer.ts